"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selector = void 0;
var getIsPlaying = function (state) { return state.place.videoPlayer.isPlaying; };
var getIsMuted = function (state) { return state.place.videoPlayer.isMuted; };
var getIsOverlayActive = function (state) { return state.place.videoPlayer.overlayActive; };
var selector = { getIsPlaying: getIsPlaying, getIsMuted: getIsMuted, getIsOverlayActive: getIsOverlayActive };
exports.selector = selector;
